import Organisation from "@higher/models/Organisation";

import { stateSubscriptionById } from "./stateSubscriptionById";

export default stateSubscriptionById<Organisation>("RoleById", "organisations");
